import { Minus, Plus } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { brl } from "@/lib/format";

export const ProductCard = ({ product, index, onConfigure }) => {
  const { qtyOf, setQty } = useCart();
  const qty = qtyOf(product.id);
  const out = product.stock <= 0;
  const isCombo = (product.option_groups || []).length > 0 || (product.addons || []).length > 0;

  return (
    <div
      data-testid={`product-card-${product.id}`}
      className="rise group flex flex-col rounded-2xl border border-white/[0.08] bg-[#1A1A1A] overflow-hidden hover:border-primo-500/40 transition-colors"
      style={{ animationDelay: `${Math.min(index, 12) * 40}ms` }}
    >
      <div className="relative aspect-square overflow-hidden bg-black/30">
        {product.image_url && (
          <img src={product.image_url} alt={product.name} loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
        )}
        <span className="absolute left-2 top-2 rounded-full bg-black/60 backdrop-blur px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-primo-300">
          {product.category}
        </span>
        {out && <div className="absolute inset-0 grid place-items-center bg-black/70 font-display font-bold text-red-400">Esgotado</div>}
        {product.compare_price > product.price && (
          <span data-testid={`product-saving-${product.id}`} className="absolute right-2 top-2 rounded-full bg-primo-500 px-2 py-0.5 text-[10px] font-extrabold uppercase tracking-wide text-white shadow-lg">
            Economize {brl(product.compare_price - product.price)}
          </span>
        )}
      </div>
      <div className="flex flex-1 flex-col gap-2 p-3">
        <h3 className="text-sm font-semibold leading-tight line-clamp-2">{product.name}</h3>
        <div className="mt-auto flex items-center justify-between gap-2">
          <div className="min-w-0">
            {product.compare_price > product.price && (
              <span data-testid={`product-compare-${product.id}`} className="block text-xs text-slate-500 line-through">{brl(product.compare_price)}</span>
            )}
            <span data-testid={`product-price-${product.id}`} className="font-display text-lg font-bold text-primo-400">{brl(product.price)}</span>
          </div>
          {isCombo ? (
            <button data-testid={`configure-combo-${product.id}`} disabled={out} onClick={() => onConfigure(product)}
              className="shrink-0 rounded-full bg-primo-500 px-3 py-1.5 text-xs font-bold text-white hover:bg-primo-400 active:scale-95 transition-transform disabled:opacity-30">
              {product.category === "Combos" ? "Montar" : "Escolher"}
            </button>
          ) : qty === 0 ? (
            <button data-testid={`add-to-cart-${product.id}`} disabled={out} onClick={() => setQty(product, 1)}
              className="grid h-9 w-9 place-items-center rounded-full bg-primo-500 text-white hover:bg-primo-400 active:scale-90 transition-transform disabled:opacity-30">
              <Plus className="h-4 w-4" strokeWidth={3} />
            </button>
          ) : (
            <div className="flex items-center gap-1 rounded-full bg-black/40 p-1">
              <button data-testid={`decrease-qty-${product.id}`} onClick={() => setQty(product, qty - 1)}
                className="grid h-7 w-7 place-items-center rounded-full bg-white/10 hover:bg-white/20"><Minus className="h-3.5 w-3.5" /></button>
              <span data-testid={`qty-${product.id}`} className="w-5 text-center text-sm font-bold">{qty}</span>
              <button data-testid={`increase-qty-${product.id}`} disabled={qty >= product.stock} onClick={() => setQty(product, qty + 1)}
                className="grid h-7 w-7 place-items-center rounded-full bg-primo-500 text-white disabled:opacity-30"><Plus className="h-3.5 w-3.5" /></button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
